import classNames from 'classnames';
import React from 'react';
import styles from './DropTargetDropTargetPlaceholder.module.scss';

interface Props {
  className?: string | null | undefined;
  children: React.ReactNode;
  canDrop: boolean;
  highlightDrop: boolean;
  style?: React.CSSProperties;
}

const DropTargetPlaceholder = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  return (
    <div
      ref={ref}
      className={classNames(styles.container, styles.dropHere, props.className, {
        [styles.canDrop]: props.canDrop,
        [styles.highlightDrop]: props.highlightDrop,
      })}
      style={props.style}
    >
      {props.children}
    </div>
  );
});

DropTargetPlaceholder.displayName = 'DropTargetPlaceholder';
export default DropTargetPlaceholder;
